import * as React from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";

export default function EmptyDialog({
  children,
  content = <></>,
  closeCallback = () => {},
}) {
  const [open, setOpen] = React.useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    closeCallback();
  };

  return (
    <React.Fragment>
      <Button variant="text" onClick={handleClickOpen}>
        {children}
      </Button>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        PaperProps={{
          style: {
            backgroundColor: "transparent",
            boxShadow: "none",
          },
        }}
      >
        {content}
      </Dialog>
    </React.Fragment>
  );
}
